export enum IncidentStatusCodeEnum {
  ABIERTO = '150',
  CERRADO = '151',
}

export interface IIncidentDataBody {
  situationId: null | number;
  stateId: null | number;
  beginDate: null | string;
  endDate: null | string;
  location?: null | string;
  address?: null | string;
  latitude?: null | number;
  lat?: null | number;
  longitude?: null | number;
  lng?: null | number;
  postalCode: null | string;
  categoryId: null | number;
  subcategoryId: null | number;
  involvedAmount: null | number;
  sourceId: null | number;
  mediaId: null | number;
  priorityId: null | number;
  impactId?: null | number;
  severityId?: null | number;
  description: null | string;
  involvedVehicles?: any[];
  files?: any[];
  creationDate?: null | string;
  updateDate?: null | string;
  [key: string]: any;
}
